import { render, staticRenderFns } from "./portraitQuery.vue?vue&type=template&id=4ded8b00&scoped=true&"
import script from "./portraitQuery.vue?vue&type=script&lang=js&"
export * from "./portraitQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded8b00",
  null
  
)

component.options.__file = "portraitQuery.vue"
export default component.exports